module.exports = require("userful-chronos-common-store/dist/integration");